var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5001 12.5719L12.0001 19.9999L4.50006 12.5719C4.00536 12.0905 3.6157 11.5119 3.3556 10.8726C3.09551 10.2332 2.97062 9.54688 2.98879 8.85687C3.00697 8.16685 3.16782 7.48807 3.46121 6.86327C3.75461 6.23847 4.17419 5.68119 4.69354 5.22651C5.21289 4.77184 5.82076 4.42962 6.47887 4.22141C7.13697 4.01321 7.83106 3.94352 8.51743 4.01673C9.20379 4.08995 9.86756 4.30449 10.4669 4.64684C11.0663 4.98919 11.5883 5.45193 12.0001 6.00593C12.4136 5.45595 12.9362 4.99725 13.5352 4.65854C14.1341 4.31982 14.7966 4.10838 15.481 4.03745C16.1654 3.96652 16.8571 4.03763 17.5128 4.24632C18.1685 4.45502 18.7741 4.79681 19.2916 5.2503C19.8091 5.70379 20.2275 6.25922 20.5205 6.88182C20.8135 7.50443 20.9748 8.18082 20.9944 8.86864C21.0139 9.55647 20.8913 10.2409 20.6342 10.8792C20.3771 11.5174 19.991 12.0958 19.5001 12.5779",
    stroke: "#F92950",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon3);
export default __webpack_public_path__ + "static/media/account-icon3.c789437199a8c61c3a382c7c4edf109b.svg";
export { ForwardRef as ReactComponent };